import { ChangeDetectionStrategy, Component, computed, input, type InputSignal, type Signal } from '@angular/core';
import { UiProgressBarComponent, type UiStateTone } from '@nexus/frontend-shared-ui';

@Component({
  selector: 'wishlist-progress-summary',
  imports: [UiProgressBarComponent],
  templateUrl: './wishlist-progress-summary.component.html',
  styleUrl: './wishlist-progress-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WishlistProgressSummaryComponent {
  public readonly label: InputSignal<string> = input.required<string>();
  public readonly value: InputSignal<number> = input.required<number>();
  public readonly max: InputSignal<number> = input.required<number>();
  public readonly secondaryLabel: InputSignal<string | null> = input<string | null>(null);
  public readonly tone: InputSignal<UiStateTone> = input<UiStateTone>('success');
  public readonly compact: InputSignal<boolean> = input<boolean>(false);

  protected readonly hasSecondaryLabel: Signal<boolean> = computed((): boolean => this.secondaryLabel() !== null);
}
